/** Only subject-free follow-ups inherit a subject. A new named product remains
 * a new request; assistant prose is never used to choose the user's subject. */
export function isDetailFollowup(question:string):boolean{
 const text=question.normalize('NFKC').trim();
 return /^(?:请|再|帮我|麻烦|继续)?(?:详细|具体|逐项|逐条|分别|进一步|全面|完整)*(?:讲解|介绍|解释|展开|说明|说说|讲讲)(?:一下)?(?:每一块|每块|各模块|每个模块|各部分|每一部分|全部|所有|上述|上面|前面|这些|这个方案|这份方案)?(?:的)?(?:内容|能力|功能|核心内容)?[。？！!\s]*$/.test(text)
  || /^(?:请|再)?(?:每一块|每块|各模块|每个模块|各部分|每一部分)(?:的内容)?(?:都)?(?:详细|具体|逐项|分别)*(?:讲解|介绍|解释|展开|说明)(?:一下)?[。？！!\s]*$/.test(text)
  || /^(?:请|再|更)?详细(?:一些|一点|点)[。？！!\s]*$/.test(text)
  || /^(?:请)?从上一个未完成回答的断点接着写/.test(text)
  || /^(?:请)?继续(?:生成|讲解|展开)?[。？！!\s]*$/.test(text);
}
const marketOnly=(text:string)=>/^\s*(?:国内(?:市场)?|海外(?:市场)?|跨境|国内和海外|两者|都需要|先看通用能力)[。！!\s]*$/.test(text);
type Turn={role:string;text:string;status?:string;continuable?:boolean};
/** Keep the latest substantive USER request through repeated detail/continue
 * turns while retaining the existing eight-message request bound. */
export function boundedConversationHistory(messages:readonly Turn[]){
 const eligible=messages.filter(m=>(m.role==='user'||m.role==='assistant')&&(m.status==='complete'||m.continuable&&m.text.trim()));
 const recent=eligible.slice(-8),anchor=[...eligible].reverse().find(m=>m.role==='user'&&!isDetailFollowup(m.text)&&!marketOnly(m.text));
 const selected=anchor&&!recent.includes(anchor)?[anchor,...recent.slice(-7)]:recent;
 return selected.map(({role,text,continuable})=>({role:role as 'user'|'assistant',text,incomplete:Boolean(continuable)}));
}
